import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0C0A09]">
        <p className="ee-overline animate-pulse">Loading…</p>
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
